import { defineMessages, useIntl } from 'react-intl'
import MobileAppScreenshot from '../../../assets/homes/img/16x9-mobile-app-estimate-value.png'
import {
  Card,
  CardBody,
  CardProps,
  Flex,
  Icon,
  Image,
  LinkBox,
  LinkOverlay,
  Spacer,
  Text
} from '@homebotapp/hb-react-component-catalog'
import { setIsShowingNativeAppCtaModal } from '../../../store/slices/modals'
import { useDispatch } from 'react-redux'

export const MSG = defineMessages({
  alt: {
    id: 'SidebarMobileAppAd.imageAlt',
    defaultMessage: 'New Homebot Mobile App'
  },
  headline: {
    id: 'SidebarMobileAppAd.headline',
    defaultMessage: 'Want to be smarter than your neighbors? Get the app.'
  },
  stayInformed: {
    id: 'SidebarMobileAppAd.stayInformed',
    defaultMessage: 'Stay informed'
  }
})

export interface SidebarMobileAppAdProps extends CardProps {
  tracking: {
    guid: string
    ui_context: string
  }
}

export const SidebarMobileAppAd = ({ tracking, ...cardProps }) => {
  const intl = useIntl()
  const dispatch = useDispatch()

  const handleClick = e => {
    e.preventDefault()
    dispatch(setIsShowingNativeAppCtaModal(true))
  }

  return (
    <LinkBox>
      <Card
        {...cardProps}
        onClick={handleClick}
        size='sm'
        role='button'
        overflow='hidden'
        _focusWithin={{
          boxShadow: 'outline'
        }}
      >
        <Image src={MobileAppScreenshot} alt={intl.formatMessage(MSG.alt)} />
        <CardBody>
          <LinkOverlay href='#' onClick={handleClick} tracking={tracking}>
            <Flex direction='row' alignItems='center' marginBottom='1'>
              <Text size='3xs' textTransform='uppercase' color='primary.700' marginBottom='0'>
                {intl.formatMessage(MSG.stayInformed)}
              </Text>
              <Spacer />
              <Icon name='circle-arrow-right-bts' color='primary.700' width='3' height='3' />
            </Flex>
          </LinkOverlay>
          <Text color='neutral.900' size='2xs' fontWeight='semibold' mb='0'>
            {intl.formatMessage(MSG.headline)}
          </Text>
        </CardBody>
      </Card>
    </LinkBox>
  )
}
